<template>
  <div>
    <div :class="{ 'inpage-cla': appKey }" class="search-bar-margin-bottom-cla">
      <el-form :inline="true" :model="params">
        <el-form-item :label="$t('attendanceRecord.commitTime')">
          <el-date-picker
            class="pickData_cla"
            v-model="timePick"
            @clear="searchFn"
            align="right"
            unlink-panels
            range-separator="-"
            :start-placeholder="$t('common.startTime')"
            :end-placeholder="$t('common.endTime')"
            :picker-options="pickerOptions"
            type="datetimerange"
            :default-time="['00:00:00', '23:59:59']"
            format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('devicesCommand.commandResult')">
          <el-select clearable v-model="params.flag" placeholder>
            <el-option
              :label="$t('devicesCommand.success')"
              value="1"
            ></el-option>
            <el-option :label="$t('devicesCommand.fail')" value="0"></el-option>
            <el-option :label="$t('devicesCommand.all')" value></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('devicesCommand.status')">
          <el-select clearable v-model="params.status" placeholder>
            <el-option
              :label="$t('devicesCommand.status0')"
              value="0"
            ></el-option>
            <el-option
              :label="$t('devicesCommand.status1')"
              value="1"
            ></el-option>
            <el-option
              :label="$t('devicesCommand.status2')"
              value="2"
            ></el-option>
            <el-option
              :label="$t('devicesCommand.status3')"
              value="3"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="!devSn" :label="$t('device.sn')">
          <el-input
            clearable
            @clear="searchFn"
            :placeholder="this.$t('device.snRequire')"
            v-model.trim="params.sn"
            @keyup.enter.native="searchFn"
          >
          </el-input>
        </el-form-item>

        <el-form-item v-if="!devSn" :label="$t('devicesCommand.actionId')">
          <el-input
            clearable
            @clear="searchFn"
            v-model.trim="params.actionId"
            @keyup.enter.native="searchFn"
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="searchFn" type="primary" icon="el-icon-search">{{
            $t('common.search')
          }}</el-button>
        </el-form-item>

        <el-form-item>
          <el-button
            @click="sendCommandByCmdIds"
            type="primary"
            :disabled="multipleSelection.length === 0"
            icon="el-icon-search"
            >{{ $t('devicesCommand.ratchResend') }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div :class="{ 'inpage-black_panel_cla': appKey }" class="black_panel_cla">
      <el-table
        ref="multipleTable"
        :data="tableData"
        :expand-row-keys="expands"
        :row-key="getRowKeys"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column
          prop="id"
          :label="this.$t('devicesCommand.comId')"
          width="90"
        ></el-table-column>
        <el-table-column
          prop="sn"
          :label="this.$t('devicesCommand.sn')"
          :show-overflow-tooltip="true"
        ></el-table-column>

        <el-table-column
          prop="protocol"
          :label="this.$t('devicesCommand.protocol')"
        ></el-table-column>

        <el-table-column
          prop="content"
          :label="this.$t('devicesCommand.content')"
        >
          <template slot-scope="scope">
            <div
              style="
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              "
            >
              {{ scope.row.content }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="commitTime"
          :label="this.$t('devicesCommand.committime')"
        >
          <template slot-scope="scope">
            {{ scope.row.commitTime | dataFormat }}
          </template>
        </el-table-column>

        <el-table-column
          prop="status"
          :label="this.$t('devicesCommand.status')"
          :show-overflow-tooltip="true"
          width="100"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">
              {{ $t('devicesCommand.status0') }}
            </span>
            <span v-if="scope.row.status === 1">
              {{ $t('devicesCommand.status1') }}
            </span>
            <span v-if="scope.row.status === 2">
              {{ $t('devicesCommand.status2') }}
            </span>
            <span v-if="scope.row.status === 3">
              {{ $t('devicesCommand.status3') }}
            </span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('devicesCommand.result')" width="100">
          <template slot-scope="scope">
            <span
              style="color: #78bc27"
              v-if="
                scope.row.returnValue === '0' ||
                  scope.row.returnValue === '00000000'
              "
              >{{ $t('devicesCommand.success') }}</span
            >
            <span
              style="color: #ea1422"
              v-else-if="
                scope.row.returnValue &&
                  scope.row.returnValue !== '' &&
                  scope.row.returnValue !== 'null'
              "
              >{{ $t('devicesCommand.fail') }}
              <i
                @click="resendCommandByCmdId(scope.row)"
                style="margin-left:10px"
                class="zk-icon-spinner11"
              ></i>
            </span>
            <span v-else>
              N/A
              <!-- {{$t('devicesCommand.fail')}} -->
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('common.action')">
          <template slot-scope="scope">
            <span
              class="btn-text-cla"
              @click.stop="toggleRowExpansion(scope.row)"
              >{{ $t('common.details') }}</span
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-margin-top">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pager.curPage"
          :page-size="pager.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pager.total"
        ></el-pagination>
      </div>

      <el-drawer :visible.sync="drawer" :with-header="false">
        <div class="api-log-detail-cla" v-if="currentRow">
          <div class="item-detail-cla">
            <lable>{{ $t('devicesCommand.content') }}:</lable>
            <div style="padding-left: 20px;word-break: break-all">
              {{ currentRow.content }}
            </div>
          </div>

          <div
            v-if="currentRow.returnTime && currentRow.returnTime !== ''"
            class="item-detail-cla"
          >
            <lable> {{ $t('devicesCommand.returnTime') }}:</lable>
            <div>
              {{ currentRow.returnTime | dataFormat }}
            </div>
          </div>

          <div
            v-if="
              currentRow.returnValue === '0' ||
                (currentRow.returnValue && currentRow.returnValue !== '')
            "
            class="item-detail-cla"
          >
            <lable> {{ $t('devicesCommand.returnValue') }}:</lable>
            <div>{{ currentRow.returnValue }}</div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import * as commandApi from '@/services/commandApi.js'
import pickerOptions from '@/utils/pickerOptions.js'
import { getCurrentDateStartAndEndTime } from '@/utils/utils.js'

export default {
  data() {
    return {
      drawer: false,
      currentRow: null,
      pickerOptions: pickerOptions(this),
      timePick: getCurrentDateStartAndEndTime(),
      expands: [],
      params: {
        sn: '',
        status: '',
        flag: '',
        actionId: ''
      },
      tableData: [],
      multipleSelection: []
    }
  },
  props: {
    appKey: {
      type: String,
      default: ''
    },
    devSn: {
      type: String,
      default: ''
    }
  },
  watch: {
    devSn: {
      handler: function(val) {
        this.params.sn = val
      },
      immediate: true
    }
  },

  mounted() {
    this.commQuery()
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    sendCommandByCmdIds() {
      let ids = this.multipleSelection.map(item => {
        return item.id
      })
      this.$confirm(
        this.$t('devicesCommand.sendCommandsTip', { length: ids.length }),
        this.$t('common.notice'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      ).then(() => {
        commandApi
          .resendCommandByCmdIds({
            cmdIds: ids
          })
          .then(data => {
            if (data.code === '00000000') {
              this.successMessage()
              this.$refs.multipleTable.clearSelection()
            } else {
              this.errorMessage(data.message)
            }
          })
          .catch(e => {
            this.errorMessage(e)
          })
      })
    },
    resendCommandByCmdId(row) {
      this.$confirm(
        this.$t('devicesCommand.sendCommandTip'),
        this.$t('common.notice'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      ).then(() => {
        commandApi
          .resendCommandByCmdId({
            cmdId: row.id
          })
          .then(data => {
            if (data.code === '00000000') {
              this.successMessage()
            } else {
              this.errorMessage(data.message)
            }
          })
          .catch(e => {
            this.errorMessage(e)
          })
      })
    },
    getRowKeys(row) {
      return row.id
    },
    toggleRowExpansion(row) {
      this.drawer = true
      this.currentRow = row
      if (this.expands.length > 0 && this.expands[0] === row.id) {
        this.expands = []
      } else {
        this.expands = []
        this.expands.push(row.id)
      }
    },
    handleSizeChange(pageSize) {
      this.pager.pageSize = pageSize
      this.commQuery()
    },
    handleCurrentChange(current) {
      this.pager.curPage = current
      this.commQuery()
    },
    searchFn() {
      this.pager.curPage = 1
      this.commQuery()
    },
    commQuery() {
      if (this.timePick && this.timePick.length === 2) {
        this.params.beginTime = this.timePick[0].getTime()
        this.params.endTime = this.timePick[1].getTime()
      } else {
        this.params.beginTime = ''
        this.params.endTime = ''
      }
      if (this.appKey !== '') {
        this.params.appKey = this.appKey
      }
      let params = {
        params: this.params,
        pager: this.pager
      }
      commandApi
        .findCommandListByPage(params)
        .then(data => {
          if (data.code === '00000000') {
            this.tableData = data.payload.results
            this.pager.total = data.payload.totalRecords
            this.pager.curPage = data.payload.curPage
            this.pager.pageSize = data.payload.pageSize
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage()
        })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/var.less';
.inpage-black_panel_cla,
.inpage-cla {
  padding-left: 0px;
}
.arrow_icon {
  position: absolute;
  top: -20px;
  right: 9.5%;
  width: 0px;
  height: 0px;
  border: 20px solid;
  border-color: transparent transparent #a99e9e transparent;
}
.arrow_icon2 {
  position: absolute;
  top: -18px;
  z-index: 1000;
  right: 9.5%;
  width: 0px;
  height: 0px;
  border: 20px solid;
  border-color: transparent transparent #eceaea transparent;
}
.logDeatil_cla {
  position: relative;
  background: #eceaea;
  border-radius: 20px;
  border: 1px solid #a99e9e;
  width: 98%;
  margin: 20px auto;
}
.logItem_cla {
  line-height: 1.5;
  .logItem_label {
    float: left;
    padding-right: 10px;
    font-size: 12px;
    color: #333333;
    text-align: right;
    width: 100px;
  }
  .logItem_value {
    display: flow-root;
    word-break: break-word;
    font-size: 12px;
    color: #999999;
  }
}
.el-tooltip__popper {
  max-width: 35%;
}
.el-popover {
  max-width: 35% !important;
}
.api-log-detail-cla {
  padding: 15px;
  .item-detail-cla {
    // lable{
    //   padding-right: 20px;
    // }
    padding: 15px 0px;
    border-bottom: 1px solid #dedcda;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/deviceManager/devicesCommand.vue